<template lang="pug">
    v-dialog(
        v-model="_value"
        width="700px"
        :transition="false"
    )
        v-card
            v-toolbar(
                :color="colors.primary"
                dark
            )   
                v-icon.mr-2 search
                span.title Búsqueda
            div.menu
                div.menu-entry.teal.white--text(
                    @click="emitOptionAndClose(1)"
                    )
                    span.font-weight-bold.subheading [F2] - Código Interno
                div.menu-entry.indigo.white--text(
                    @click="emitOptionAndClose(2)"
                )
                    span.font-weight-bold.subheading [F3] - Buscador
            input.handler(
                v-if="_value"
                ref="inp"
                @blur="handleBlur"
                @keydown="handleKeys($event)"
            )
</template>

<script>
// -- Component Imports --
// -- JS Data files import --
// -- JS Libraries Import --
// -- Mixins imports --
// -- Vuex Imports --
// -- Other Imports --
export default {
    name: 'search-type-modal',
    props: {
        // ------------------------- UI State ---------------------------------
        /**
         * @description
         */
        value: {
            type: Boolean,
            default: () => false
        },
        // ------------------------- Component Data ---------------------------
    },
    data: function(){
        return {
            // ------------------------ UI State ------------------------------
            // ------------------------ Data storing --------------------------
        }
    },
    computed: {
        // -------------------- Editable props binding-------------------------
        /**
         * @description
         */
        _value: {
            get: function(){
                return this.value
            },
            set: function(val){
                this.$emit('input', val)
            },
        },
        // -------------------- Alias settings --------------------------------
        // -------------------- Dynamic UI State ------------------------------
        // -------------------- Displayed data --------------------------------
        // -------------------- Methods data ----------------------------------
        // -------------------- Vuex mappings ---------------------------------
    },
    methods: {
        // -------------------- UI Modification -------------------------------
        // -------------------- Data fetching ---------------------------------
        // -------------------- Data handling and transformations -------------
        // -------------------- Validations and Error handling ----------------
        // -------------------- Other functions -------------------------------
        handleKeys(e){
            if(e.keyCode === 27){
                this._value = false
            }
            if(e.keyCode === 113 || e.keyCode === 114){
                e.preventDefault()
                e.stopImmediatePropagation()
                e.stopPropagation()
                this.emitOptionAndClose(e.keyCode === 113 ? 1 : 2)
            }
        },
        emitOptionAndClose(opt){
            this.$emit('option:select', opt)
            this._value = false
        },
        handleBlur(){
            this.$nextTick(() => this.$refs.inp.focus())
        }
        // -------------------- Vuex mappings ---------------------------------
    },
    watch: {
        value: {
            handler(val){
                if(val) this.$nextTick(() => this.$refs.inp.focus())
            },
            immediate: true
        }
    },
    // components: {},
    // mixins: [],
    // filters: {},
    // ------------------------ Lifecycle Methods -----------------------------
    // ------------------------ End Lifecycle Methods -------------------------
}
</script>

<style lang="scss" scoped>
.menu{
    padding: 10px;
    padding-bottom: 5px;
    width: 100%;
    .menu-entry{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        width: 100%;
        height: 50px;
        padding-left: 20px;
        margin-bottom: 5px;
        cursor: pointer;
    }
}
.handler{
    opacity: 0;
}

</style>